import { render, staticRenderFns } from "./VisualizarTransacao.vue?vue&type=template&id=7f4403c0"
import script from "./VisualizarTransacao.vue?vue&type=script&lang=js"
export * from "./VisualizarTransacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports